export default "__VITE_ASSET__DGUWOhKB__"